import { messages } from "../../../src/resources/strings";
import { useAppDispatch, useAppSelector } from "../../store/Store";
import { getPolicyNumber } from "../../utilities/Helpers";
import CheckSession from "../../utilities/CheckSession";
import {
  setError,
  setLoading,
  setPaymentsLoading,
  updatePreviousPayments,
} from "../../store/slices/PolicyDetailSlice";
import { getPreviousPaymentsDetails } from "../billing";
import { handleInvalidTokenCase } from "../../utilities/AuthHelper";
import { useNavigation } from "@react-navigation/native";
import { useAuth0 } from "@auth0/auth0-react";

const billingHandler = () => {
  const { logout } = useAuth0();
  const navigation = useNavigation();
  const dispatch = useAppDispatch();
  const { isConnected } = useAppSelector((state) => state.userReducer);

  const fetchPayments = async () => {
    const session = await CheckSession();
    if (session) {
      fetchPreviousPayments();
    } else {
      handleInvalidToken();
    }
  };

  const fetchPreviousPayments = async () => {
    try {
      dispatch(setLoading(true));
      dispatch(setPaymentsLoading(true));
      const policyNumber = await getPolicyNumber();
      const res = await getPreviousPaymentsDetails(policyNumber);
      if (res) {
        dispatch(updatePreviousPayments(res?.response));
        if (!policyNumber) {
          dispatch(setError(messages.error.noDataFound));
        }
      }
    } finally {
      setTimeout(() => {
        dispatch(setLoading(false));
        dispatch(setPaymentsLoading(false));
      }, 900);
    }
  };
  const handleInvalidToken = () => {
    handleInvalidTokenCase(isConnected ?? false, navigation, logout, () => {});
  };

  return {
    fetchPayments,
  };
};

export default billingHandler;
